import React from 'react';
import { X } from 'lucide-react';

interface VideoModalProps {
  onClose: () => void;
}

const VideoModal = ({ onClose }: VideoModalProps) => {
  return (
    <div 
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-black w-full max-w-4xl rounded-xl overflow-hidden relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors z-10"
        >
          <X className="h-5 w-5 text-white" />
        </button>
        
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            src="https://player.vimeo.com/video/1082678307?h=8bf59af3a7&badge=0&autopause=0&player_id=0&app_id=58479"
            className="absolute top-0 left-0 w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
            title="Double Me Overview"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoModal;